<main>
    <header>
        @if (!isInternal) {
            <nav class="navbar">
                <div class="logo">
                    <img class="image" src="assets/images/zee-products/zee-logo.png" alt="zee logo">
                </div>

                <h2 class="site-title">
                    <img src="assets/svgs/zee-products/fleet-white.svg" alt="operation white logo" />
                    <span>Fleet</span>
                </h2>
            </nav>
        }

        <div class="stepper">
            <span class="item" [class.selected]="currentStep() === 1">1</span>
            <hr>
            <span class="item" [class.selected]="currentStep() === 2">2</span>
            <hr>
            <span class="item" [class.selected]="currentStep() === 3">3</span>
        </div>

        <h2 class="title">Detalles del rebalanceo</h2>
    </header>

    <section class="form-wrapper">

        @switch (currentStep()) {
            @case (1) {
                <app-first-step (completeSave)="getRebalancing()" [rebalance]="rebalance" [currentStep]="currentStep"></app-first-step>
            }
            @case (2) {
                <app-second-step [rebalance]="rebalance" [currentStep]="currentStep"></app-second-step>
            }
            @case (3) {
                <app-third-step [rebalance]="rebalance" [isInternal]="isInternal"></app-third-step>
            }
        }
    </section>
</main>
